// extracted by mini-css-extract-plugin
export default {"wrapper":"tableShimmer_wrapper__+B6EP","row":"tableShimmer_row__dMZzk","cell":"tableShimmer_cell__AWXFj","shimmer":"tableShimmer_shimmer__s3mEJ"};